import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { FaAngleLeft } from 'react-icons/fa6';
import { toast } from 'react-toastify';
import CardsProgressSteps from '../../../../components/ProgressStep/CardsProgressSteps';
import { validateVirtualCardCreation } from '../../../../api/api'; 

const CreateCardAddress = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const storedCardDetails = location.state?.customizedCardDetails;
    const amount = location.state?.amountFunded;
    const prevPayload = location.state?.creationPayload;

    const [accountPurpose, setAccountPurpose] = useState(prevPayload?.accountPurpose || "")
    const [expectedMonthlyVolume, setExpectedMonthlyVolume] = useState(prevPayload?.expectedMonthlyVolume || "")    
    const [loading, setLoading] = useState(false);

    const handleGoBack = () => {
        navigate("/user/cards/fund_card", {
            state: {
                amountFunded: amount,
                customizedCardDetails: storedCardDetails,
                creationPayload: {
                    accountPurpose,
                    expectedMonthlyVolume,
                }
            }
        });
    };

    const handleContinue = async () => {
        if (!accountPurpose || !expectedMonthlyVolume) {
            toast.error("Please fill in all fields");
            return;
        }

        setLoading(true);
        try {
            const cardCurrency = storedCardDetails?.cardCurrency;
            const payload = {
                nickname: storedCardDetails?.nickname,
                card_type: storedCardDetails?.cardType || 'virtual',
                card_brand: storedCardDetails?.cardSlug,
                card_currency: cardCurrency,
                funding_amount: parseFloat(amount),
                expected_monthly_volume: expectedMonthlyVolume,
                account_purpose: accountPurpose,
            };

            const response = await validateVirtualCardCreation(payload);
            const validationData = response.data?.data || {};

            navigate("/user/cards/review_card", {
                state: {
                    amountFunded: parseFloat(amount),
                    validationData: validationData,
                    creationPayload: payload,
                    customizedCardDetails: storedCardDetails
                }
            });
        } catch (error) {
            let errorMsg = "Validation failed. Please try again.";
            if (error.response?.data?.message) {
                errorMsg = error.response.data.message;
                if (error.response.data.errors) {
                    const firstErrorKey = Object.keys(error.response.data.errors)[0];
                    if (firstErrorKey) {
                        errorMsg = error.response.data.errors[firstErrorKey][0];
                    }
                }
            }
            toast.error(errorMsg, {
                toastId: "validation-error-toast",
                className: "custom-toast",
            });
        } finally {
            setLoading(false);
        }
    };

    return (
        <section className='create__card__page card__fund__page pt-4'>
            <div className="d-flex align-items-center mb-4 px-md-3">
                <button
                    onClick={handleGoBack}
                    className="btn btn-light d-flex align-items-center shadow-sm"
                    style={{
                        borderRadius: '20px',
                        padding: '6px 16px',
                        backgroundColor: '#ffffff',
                        border: '1px solid #E0E4EC',
                        color: '#19064B',
                        fontWeight: '500',
                        fontSize: '13px',
                        gap: '6px'
                    }}
                >
                    <FaAngleLeft size={13} />
                    <span>Go back</span>
                </button>
            </div>

            <section><CardsProgressSteps currentStep={4} /></section>

            <section className="create-card_section funding__card__section pt-5">
                <div className="container">
                    <div className="funding__form mx-auto" style={{ maxWidth: '480px' }}>
                        <div className="form__card-section p-4 bg-white shadow-sm" style={{ borderRadius: '24px', border: '1px solid #E0E4EC' }}>
                            <div className="mb-4">
                                <label className="form-label fw-medium text-muted mb-2" style={{ fontSize: '13px' }}>
                                    What will you use this card for? <span className="text-danger">*</span>
                                </label>
                                <select className="form-control" value={accountPurpose} onChange={(e) => setAccountPurpose(e.target.value)} required>
                                    <option value="" disabled>Select card purpose</option>
                                    <option value="online_shopping">Online Shopping</option>
                                    <option value="subscriptions">Subscriptions & Digital Services</option>
                                    <option value="advertising">Digital Advertising</option>
                                    <option value="business_expenses">Business Expenses</option>
                                    <option value="travel">Travel & Accommodation</option>
                                    <option value="education">Education & Online Courses</option>
                                    <option value="software_tools">Software & Work Tools</option>
                                    <option value="freelancing">Freelancing & Remote Work</option>
                                    <option value="personal_expenses">Personal Expenses</option>
                                    <option value="other">Other</option>
                                </select>
                            </div>

                            <div className="row g-3 mb-4">
                                <label className="form-label fw-medium text-muted mb-2" style={{ fontSize: '13px' }}>
                                    Expected Monthly Spend <span className="text-danger">*</span>
                                </label>
                                
                            </div>

                            <div className="mt-5">
                                <button onClick={handleContinue} className="btn w-100 py-3 fw-semibold text-white shadow-sm" disabled={!expectedMonthlyVolume || !accountPurpose || loading} 
                                    style={{ backgroundColor: '#0A95FF', borderRadius: '14px', fontSize: '15px', transition: 'all 0.3s' }}
                                >
                                    {loading ? (
                                        <><span className="spinner-border spinner-border-sm me-2"></span>Validating...</>
                                    ) : "Continue"}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </section>
    );
};

export default CreateCardAddress;
